import { Link } from "react-scroll";
import { FaLinkedinIn, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { HiMail } from "react-icons/hi";

export default function Sidebar({ navLinks, isOpen, setOpen }) {
  return (
    <div className="">
      <ul className="top-20 fixed w-3/5 sm:w-2/5 transition ease-in-out duration-200 right-0 bg-[#191919] h-[100vh] space-y-4 z-10">
        {navLinks.map((items, index) => (
          <li key={index} className="p-4 text-lg cursor-pointer font-semibold ">
            <Link
              to={items.path}
              activeClass="active"
              spy={true}
              smooth={true}
              duration={500}
              offset={-100}
              onClick={() => setOpen(!isOpen)}
            >
              {items.name}
            </Link>
          </li>
        ))}

        <div
          style={{ marginBottom: 20 }}
          className="px-5 text-xl fixed bottom-0 flex justify-center"
        >
          <ul className="space-x-5 flex items-center justify-center">
            <li className="">
              <a
                href="https://wa.link/uws0lz"
                target="_blank"
                rel="noopener noreferrer"
                title="Whatsapp link icon"
                alt="Whatsapp icon"
                className="text-white"
              >
                <FaWhatsapp />
              </a>
            </li>
            <li className="">
              <a
                href="mailto:ejembijoshman@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                title="Email link icon"
                alt="email icon"
                className="text-white"
              >
                <HiMail />
              </a>
            </li>
            <li className="">
              <a
                href=" https://www.linkedin.com/in/blaq-dev"
                target="_blank"
                rel="noopener noreferrer"
                title="Linkedin icon link"
                alt="linkedin icon"
                className="text-white"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="">
              <a
                href="https://twitter.com/blaqdev"
                target="_blank"
                rel="noopener noreferrer"
                title="Twitter link Icon"
                alt="twitter icon"
                className="text-white"
              >
                <FaTwitter />
              </a>
            </li>
            <li className="">
              <a
                href="https://github.com/106joshman"
                target="_blank"
                rel="noopener noreferrer"
                title="Github link Icon"
                alt="github icon"
                className="text-white"
              >
                <BsGithub />
              </a>
            </li>
          </ul>
        </div>
      </ul>
    </div>
  );
}
